import React from "react"
import { BounceLoader } from "react-spinners"
import { Microsoft365 } from "./platform-microsoft"
import { GoogleWorkspace } from "./platform-google"

import "./style.scss"

export const SubmittingLoader = () => {
    return (
        <div className="sbt">
            <h1 className="sbt-title">
                <span>We're checking if your email address is compatible</span>
            </h1>
            <BounceLoader className="sbt-loader" size={64} color={"#38aecc"} />
            <div className="sbt-logo">
                <GoogleWorkspace />
                <Microsoft365 />
            </div>
        </div>
    )
}
